// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

import theme from './theme';

for (const themeColor in theme) {
  if (themeColor) {
    document.getElementsByTagName('html')[0].style.setProperty('--' + themeColor, (theme as any)[themeColor]);
  }
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: { expand: 'mdi-menu-down' },
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});
